import ApiServer from '@/utils/api/ApiServer.js'
import { rateSheetDefinitionSorter, rateSheetDefinitionVersionSorter, rateSheetDefinitionLineFromServerToBuilder } from '@/components/account/account-scaling/rate-sheet-definitions/RateSheetDefinitions'

const ACCOUNTS = 'accounts'
const RATE_SHEET_DEFINITIONS = 'rateSheetDefinitions'
const VERSIONED_RATES = 'versionedRates'
const LINES = 'lines'

function safeSort (responseData, sortingFunction) {
  if (responseData && responseData.length > 1) {
    responseData.sort(sortingFunction)
  }
}

export default {
  async fetchAccountRateSheetDefinitions (context, accountId) {
    context.commit('setRateSheetDefinitionsLoading', true)
    const response = await ApiServer.get(`${ACCOUNTS}/${accountId}/${RATE_SHEET_DEFINITIONS}`)
    safeSort(response?.data, rateSheetDefinitionSorter)
    context.commit('setRateSheetDefinitions', response.data)
    context.commit('setRateSheetDefinitionsLoading', false)
    return response.data
  },
  async fetchAccountRateSheetDefinition (_, { accountId, rateSheetDefinitionId }) {
    const response = await ApiServer.get(`${ACCOUNTS}/${accountId}/${RATE_SHEET_DEFINITIONS}/${rateSheetDefinitionId}`)
    return response.data
  },
  async createAccountRateSheetDefinition (_, rateSheetDefinition) {
    const response = await ApiServer.post(`${ACCOUNTS}/${rateSheetDefinition.accountId}/${RATE_SHEET_DEFINITIONS}`, rateSheetDefinition)
    return response.data
  },
  async updateAccountRateSheetDefinition (_, rateSheetDefinition) { // TODO MK: Use actual update query when it exists
    console.debug('updateAccountRateSheetDefinition NOT IMPLEMENTED YET')
    console.debug(JSON.stringify(rateSheetDefinition, null, '  '))
    // const response = await ApiServer.put(`${ACCOUNTS}/${rateSheetDefinition.accountId}/${RATE_SHEET_DEFINITIONS}/${rateSheetDefinition.rateSheetDefinitionId}`, rateSheetDefinition)
    // return response.data
    // await ApiServer.delete(`${ACCOUNTS}/${rateSheetDefinition.accountId}/${RATE_SHEET_DEFINITIONS}/${rateSheetDefinition.rateSheetDefinitionId}`)
    // const response = await ApiServer.post(`${ACCOUNTS}/${rateSheetDefinition.accountId}/${RATE_SHEET_DEFINITIONS}`, rateSheetDefinition)
    // return response.data
  },
  async deleteAccountRateSheetDefinition (_, { accountId, rateSheetDefinitionId }) {
    const response = await ApiServer.delete(`${ACCOUNTS}/${accountId}/${RATE_SHEET_DEFINITIONS}/${rateSheetDefinitionId}`)
    return response.data
  },

  async fetchVersionedRateSheetDefinition (context, { accountId, rateSheetDefinitionId }) {
    context.commit('setVersionedRateSheetDefinitionsLoading', true)
    const response = await ApiServer.get(`${ACCOUNTS}/${accountId}/${RATE_SHEET_DEFINITIONS}/${rateSheetDefinitionId}/${VERSIONED_RATES}`)
    safeSort(response?.data, rateSheetDefinitionVersionSorter)
    const responseDataFormatted = response.data.map(vrsd => ({
      ...vrsd,
      rateSheetDefinitionLines: vrsd.rateSheetDefinitionLines.map(rateSheetDefinitionLineFromServerToBuilder)
    }))
    context.commit('setVersionedRateSheetDefinitions', responseDataFormatted)
    context.commit('setVersionedRateSheetDefinitionsLoading', false)
    return responseDataFormatted
  },
  async createVersionedRateSheetDefinition (_, versionedRateSheet) {
    const { accountId, rateSheetDefinitionId } = versionedRateSheet
    const response = await ApiServer.post(`${ACCOUNTS}/${accountId}/${RATE_SHEET_DEFINITIONS}/${rateSheetDefinitionId}/${VERSIONED_RATES}`, versionedRateSheet)
    return response.data
  },
  async patchVersionedRateSheetDefinition (_, { accountId, rateSheetDefinitionId, versionedRateSheetId, body }) {
    const response = await ApiServer.patch(`${ACCOUNTS}/${accountId}/${RATE_SHEET_DEFINITIONS}/${rateSheetDefinitionId}/${VERSIONED_RATES}/${versionedRateSheetId}`, body)
    return response.data
  },
  async deleteVersionedRateSheetDefinition (_, { accountId, rateSheetDefinitionId, versionedRateSheetId }) {
    const response = await ApiServer.delete(`${ACCOUNTS}/${accountId}/${RATE_SHEET_DEFINITIONS}/${rateSheetDefinitionId}/${VERSIONED_RATES}/${versionedRateSheetId}`)
    return response.data
  },

  async createAccountRateSheetDefinitionLine (_, rateSheetDefinitionLine) {
    const { rateSheetDefinitionId, versionedRateSheetId, accountId } = rateSheetDefinitionLine
    const response = await ApiServer
      .post(`${ACCOUNTS}/${accountId}/${RATE_SHEET_DEFINITIONS}/${rateSheetDefinitionId}/${VERSIONED_RATES}/${versionedRateSheetId}/${LINES}`,
        rateSheetDefinitionLine)
    return response.data
  },
  async updateAccountRateSheetDefinitionLine (_, rateSheetDefinitionLine) {
    const { rateSheetDefinitionLineId, rateSheetDefinitionId, versionedRateSheetId, accountId } = rateSheetDefinitionLine
    const response = await ApiServer
      .put(`${ACCOUNTS}/${accountId}/${RATE_SHEET_DEFINITIONS}/${rateSheetDefinitionId}/${VERSIONED_RATES}/${versionedRateSheetId}/${LINES}/${rateSheetDefinitionLineId}`,
        rateSheetDefinitionLine)
    return response.data
  },
  async deleteAccountRateSheetDefinitionLine (_, { accountId, rateSheetDefinitionId, versionedRateSheetId, rateSheetDefinitionLineId }) {
    const response = await ApiServer
      .delete(`${ACCOUNTS}/${accountId}/${RATE_SHEET_DEFINITIONS}/${rateSheetDefinitionId}/${VERSIONED_RATES}/${versionedRateSheetId}/${LINES}/${rateSheetDefinitionLineId}`)
    return response.data
  },
  async patchAccountRateSheetDefinitionName (_, { accountId, rateSheetDefinitionId, body }) {
    const response = await ApiServer.patch(`${ACCOUNTS}/${accountId}/${RATE_SHEET_DEFINITIONS}/${rateSheetDefinitionId}`, body)
    return response.data
  },
  async fetchRateSheetDefinitionUsage (_, { accountId, rateSheetDefinitionIds }) {
    const params = rateSheetDefinitionIds?.length ? { rateSheetDefinitionIds: rateSheetDefinitionIds.join(',') } : {}
    const url = ApiServer.urlFor([ACCOUNTS, accountId, RATE_SHEET_DEFINITIONS, 'usage'], { params })
    const response = await ApiServer.get(url)
    return response.data
  },
  async fetchRateSheetDivergence (_, { accountId, contractTypes }) {
    const url = ApiServer.urlFor([ACCOUNTS, accountId, RATE_SHEET_DEFINITIONS, 'divergence'], { params: contractTypes })
    const response = await ApiServer.get(url)
    return response.data
  }
}
